import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Calendar, LayoutGrid, Users, ShieldCheck } from 'lucide-react';
import '../styles/VideoSection.css';

const stats = [
  { icon: LayoutGrid, value: '360°', label: 'Sistema de gestión' },
  { icon: Users,      value: '500+', label: 'Empresas activas' },
  { icon: ShieldCheck,value: 'API',  label: 'WhatsApp Cloud oficial' },
];

const VideoSection = () => {
  const [ref, inView] = useInView({ threshold: 0.08, triggerOnce: true });

  return (
    <section className="video-section" ref={ref}>
      <div className="video-section__inner">

        {/* ── Left: video ── */}
        <motion.div
          className="video-section__media"
          initial={{ opacity: 0, x: -36 }}
          animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        >
          <div className="video-section__badge">▶ Video explicativo</div>
          <div className="video-frame">
            <iframe
              src="https://www.youtube.com/embed/DWi3AwrbJnI"
              title="Runamatic - Plataforma integral de atención al cliente"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              loading="lazy"
            />
          </div>
        </motion.div>

        {/* ── Right: CTA ── */}
        <motion.div
          className="video-section__cta"
          initial={{ opacity: 0, x: 36 }}
          animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.7, delay: 0.15, ease: 'easeOut' }}
        >
          <div className="video-cta__eyebrow">Runamatic en acción</div>

          <h2 className="video-cta__title">
            Ve cómo funciona<br />
            <span className="video-cta__title--highlight">en 2 minutos</span>
          </h2>

          <p className="video-cta__desc">
            Automatiza redes sociales y WhatsApp Business sin perder tu cuenta
            en el teléfono, gracias a la tecnología de coexistencia.
          </p>

          {/* Stats */}
          <div className="video-cta__stats">
            {stats.map(({ icon: Icon, value, label }) => (
              <div key={label} className="video-cta__stat">
                <div className="video-cta__stat-icon">
                  <Icon size={17} />
                </div>
                <div>
                  <div className="video-cta__stat-value">{value}</div>
                  <div className="video-cta__stat-label">{label}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="video-cta__separator" />

          <p className="video-cta__invite">
            Agenda una llamada de asesoría <strong>gratuita</strong> y lleva tu atención al cliente al próximo nivel
          </p>

          <a
            href="https://calendar.app.google/JeF9eEUM5uRNcXvz7"
            target="_blank"
            rel="noopener noreferrer"
            className="video-cta__btn"
          >
            <Calendar size={18} />
            Agendar llamada gratis
          </a>

          <p className="video-cta__subtext">
            Un especialista en automatización IA te asesorará personalmente
          </p>
        </motion.div>

      </div>
    </section>
  );
};

export default VideoSection;
